export const pageSize = 24;
export const pageNumber = 1;